export default "__VITE_ASSET__vjAVdi59__"